import quillRegistry from "../quill_registry"

// Escape inside the comment editor leaves the editor instead of closing the
// Account or Deal modal around it. If Reply filled in a mention, Escape also
// cancels the reply: it drops the reply-to id and clears the mention when
// nothing was typed after it. While editing an existing comment, Escape leaves
// edit mode without saving.
export const CommentComposer = {
  mounted() {
    this.onKeydown = (event) => this.keydown(event)
    this.el.addEventListener("keydown", this.onKeydown)
  },

  destroyed() {
    this.el.removeEventListener("keydown", this.onKeydown)
  },

  keydown(event) {
    if (event.key !== "Escape" || event.defaultPrevented) return

    const editorEl = event.target.closest('[role="rich-text-editor"]')
    if (!editorEl) return

    const quill = quillRegistry.get(editorEl.id)
    // An open mention list takes Escape first and closes itself.
    if (quill?.getModule("mention")?.isOpen) return

    // Claimed: the modal's Escape handler skips prevented events.
    event.preventDefault()

    if (this.el.dataset.commentEditing === "true") {
      this.pushEventTo(this.el.getAttribute("phx-target"), "cancel-edit", {})
      return
    }

    this.cancelReply(quill)
    // Clearing the editor makes Quill reselect, which focuses it again, so
    // leave the editor once that has run.
    setTimeout(() => {
      quill?.blur()
      document.activeElement?.blur()
    })
  },

  cancelReply(quill) {
    const replyTo = this.el.querySelector('input[name$="[in_reply_to_id]"]')
    if (!replyTo?.value) return

    replyTo.value = ""
    // Reply inserts one mention embed; Quill adds the trailing newline.
    if (quill && quill.getLength() <= 2) quill.setContents([])
    // Sync the server-side form, so a re-render cannot restore the id.
    replyTo.dispatchEvent(new Event("input", { bubbles: true }))
  },
}
